import { Maybe } from '@Types'
import { startCase } from 'lodash'

export type OverclaimDocumentStatus = 'REVIEWED' | 'PENDING' | 'IN_REVIEW'

const reviewedLegacyStatuses = ['ACCEPTED', 'REJECTED']

export const formatOverclaimDocumentStatus = (status: string) =>
    startCase((reviewedLegacyStatuses.includes(status) ? 'REVIEWED' : status).toLowerCase())

export interface OverclaimUploadedDocument {
    id: number
    name: string
    size: number
    description: Maybe<string>
    createdAt: string
    status: OverclaimDocumentStatus
    memberUploadId: number
    documentRejectionReason?:
        'MISSING_KEY_TERM' | 'MISSING_SIGNATURE' | 'INADEQUATE_DOCUMENTATION' | 'ADDITIONAL_DOCUMENTATION_REQUIRED'
    rejectionDescription?: string
}

export type OverclaimUploadedDocumentsForPublisher = Record<string, OverclaimUploadedDocument[]>
